import { render, staticRenderFns } from "./BaseRules.vue?vue&type=template&id=2aba6a23&scoped=true&"
import script from "./BaseRules.vue?vue&type=script&lang=js&"
export * from "./BaseRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba6a23",
  null
  
)

export default component.exports